import React, { useState } from "react";
import { IoIosSwitch } from "react-icons/io";
// import { useSelector } from "react-redux";

const SocialMediaTemplatesModal = ({
  setShowSocialMediaModal,
  setShowLinkbutton8,
  setLinkbtn8Data,
    linkbtn8Data
}) => {
  const [showPreview, setShowPreview] = useState("s-design1.png");
  

  const handleClick = (e, type ) => {
    setShowSocialMediaModal(false);
    setShowLinkbutton8(true);
    setLinkbtn8Data({
      ...linkbtn8Data,
      design: type,
      xPosition: 0,
      yPosition: 0
    });
  };

  const handleOver = (e, type) => {
    if (type === "name_animation") {
      setShowPreview(type + ".png");
    } else {
      setShowPreview(type + ".png");
    }
  };

  return (
    <div
      className="modal fade show d-block"
      id="modalcreatevideo"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modalcreatevideoTitle"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-centered modal-xl"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h3>Social Media Templates</h3>
            <button
              type="button"
              className="close"
              onClick={() => {
                setShowSocialMediaModal(false);
              }}
            >
              <i
                className="fas fa-times"
                style={{ fontSize: "20px", color: "#cacccf" }}
              ></i>
            </button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-5">
                <div className="list-container p-4">
                  <div className="list-group">

                    <div className="accordion" id="accordionExample">
                      <div className="accordion-item border-0">
                        <h2 className="accordion-header" id="headingOne">
                          <button
                            className="list-group-item list-group-item-action border-0 h5 mb-0"
                            onMouseOver={(e) => handleOver(e, "s-design1")}
                            onClick={(e) => handleClick(e, "design1")}
                          >
                            <IoIosSwitch size={24} className="text-info" />{" "}
                            Social Media Design 1
                          </button>
                        </h2>
                      </div>
                    </div>
                    <button
                      className="list-group-item list-group-item-action border-0 h5 mb-0"
                      onClick={(e) => handleClick(e, "design2")}
                      onMouseOver={(e) => handleOver(e, "s-design2")}
                    >
                      <IoIosSwitch size={24} className="text-info" /> 
                      Social Media Design 2
                    </button>
                    <button
                      className="list-group-item list-group-item-action border-0 h5 mb-0"
                      onClick={(e) => handleClick(e, "design3")}
                      onMouseOver={(e) => handleOver(e, "s-design3")}
                    >
                      <IoIosSwitch size={24} className="text-info" /> 
                      Social Media Design 3
                    </button>
                    <button
                      className="list-group-item list-group-item-action border-0 h5 mb-0 "
                      onClick={(e) => handleClick(e, "design4")}
                      onMouseOver={(e) => handleOver(e, "s-design5")}
                    >
                      <IoIosSwitch size={24} className="text-info" /> 
                      Social Media Design 4
                    </button>
                    <button
                      className="list-group-item list-group-item-action border-0 h5 mb-0"
                      onClick={(e) => handleClick(e, "design5")}
                      onMouseOver={(e) => handleOver(e, "s-design4")}
                    >
                      <IoIosSwitch size={24} className="text-info" /> 
                      Social Media Design 5
                    </button>
                    
                    
                    
                  </div>
                </div>
              </div>
              <div className="col-7">
                <div className="display-container bg-light">
                  <div className="preview-template col-8 m-auto p-4">
                    <img
                      src={
                        "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/Images/" +
                        showPreview
                      }
                      className="img-fluid img-thumbnail mx-auto"
                      alt={`Preview ${showPreview}`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaTemplatesModal;
